import { Application } from "@hotwired/stimulus"
//import Select2Controller from 'stimulus-select2'
//import StimulusTomSelect from "stimulus-tom-select";
import AiwriterController from "./aiwriter_controller"
import ChoicesController from "./choices_controller"
import FlatpickrController from "./flatpickr_controller"
import { Dropdown, Toggle, Modal } from "tailwindcss-stimulus-components"
import ReactComponentController from "./react_component_controller"
import article_submit_controller from "./article_submit_controller"
// import Alpine from 'alpinejs'
// Alpine.start()

const application = Application.start()

application.register('article-submit', article_submit_controller)
application.register('modal', Modal)
application.register('dropdown', Dropdown)
application.register('toggle', Toggle)
application.register("flatpickr", FlatpickrController)
application.register("choices", ChoicesController)
application.register("aiwriter", AiwriterController)
application.register('react-component', ReactComponentController)
//application.register("tom-select", StimulusTomSelect);
// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }
